import React, { useContext } from 'react';
import { FaShoppingCart, FaSearch } from 'react-icons/fa';
import UserContext from '../context/UserContext';
const NavBar = () => {
	const context = useContext(UserContext);
	const showCart = () => {
		context.setCart(true);
		context.setViewProduct(false);
		context.setProduct({});
	};
	return (
		<div className="navbar__wrapper">
			<div className="navbar__container">
				<div className="navbar__header">
					<h2>BuyOnline</h2>
				</div>
				<div className="navbar__searchbox">
					<input
						type="text"
						value={context.query}
						onChange={(e) => context.setQuery(e.target.value)}
						placeholder="Search.."
					/>
					<FaSearch className="search__data" onClick={context.fetchData} />
				</div>
				<div className="navbar__body">
					<div className="navbar__addtoCart" onClick={() => showCart()}>
						<FaShoppingCart />
						<p>Cart</p>
						{context.cartItem.length > 0 ? (
							<div className="cartItem__marker">
								<span>{context.cartItem.length}</span>
							</div>
						) : (
							<div></div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default NavBar;
